<script setup lang="ts">
    import ProtocolTable from '../components/coaching/protocol/table/ProtocolTable.vue';
    import ProtocolTableFilter from '../components/coaching/protocol/table/ProtocolTableFilter.vue';
    import PageHeader from '../components/PageHeader.vue';
    import { __ } from '../stores/expressions';
    import { ClipboardCheckIcon } from '@lucide/vue';
</script>
<template>
    <!-- Padding left below the table at the end of the page: page-padding (1.75rem)
         plus ProtocolTableFilter's pb-7.5 (1.875rem). -->
    <div class="page-padding [--table-fill-space-below:3.625rem]">
        <PageHeader>
            <template #icon><ClipboardCheckIcon class="size-full" /></template>
            {{ __('protocol-list-title') }}
        </PageHeader>
        <div class="Card !p-0 mt-1.5 relative">
            <ProtocolTableFilter>
                <template #table>
                    <ProtocolTable />
                </template>
            </ProtocolTableFilter>
        </div>
    </div>
</template>
